import { createFileRoute } from "@tanstack/react-router";
import CreateClientForm from "@/components/CreateClientForm";

export const Route = createFileRoute("/dashboard/clients/new")({
  component: CreateClientPage,
});

function CreateClientPage() {
  return (
    <div className="p-8">
      <div className="max-w-4xl mx-auto">
        <CreateClientForm />
      </div>
    </div>
  );
}
